import React from 'react';
import PropTypes from 'prop-types';

const SideBlock = ({ title, content }) => (
    <div className="side-block">
        <div className="block-header">
            <span className="block-title font-weight-pre-bold">{title}</span>
        </div>
        <div className="sidebar-content">{content}</div>
    </div>
);

SideBlock.defaultProps = {
    title: null,
    content: null,
};

SideBlock.propTypes = {
    title: PropTypes.string,
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default SideBlock;
